
import { defineComponent } from 'vue'
import { IonCard } from '@ionic/vue';

export default defineComponent({
    components: { IonCard }
})
